import { render, staticRenderFns } from "./ImportMappings.vue?vue&type=template&id=72462d25&scoped=true&"
import script from "./ImportMappings.vue?vue&type=script&lang=js&"
export * from "./ImportMappings.vue?vue&type=script&lang=js&"
import style0 from "./ImportMappings.vue?vue&type=style&index=0&id=72462d25&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72462d25",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72462d25')) {
      api.createRecord('72462d25', component.options)
    } else {
      api.reload('72462d25', component.options)
    }
    module.hot.accept("./ImportMappings.vue?vue&type=template&id=72462d25&scoped=true&", function () {
      api.rerender('72462d25', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamSettings/ImportMappings.vue"
export default component.exports